
analyzify.log('GTM Integration script start', 'an_gtm', 'init');

try {
  // Ensure analyzify object exists (should be initialized by an_analyzify_settings.liquid)
  if (!window.analyzify) {
    console.warn('Analyzify object not found. Make sure an_analyzify_settings.liquid is loaded before this file.');
    window.analyzify = {};
  }

  // GTM configuration - uses analyzify.properties.GTM from an_analyzify_settings.liquid
  const GTM_CONFIG = window.analyzify?.properties?.GTM || {
    status: true,
    id: "GTM-XXXXXXX",
    multiple_view_item_list: true,
    enhanced_params: true,
    variant_changed: true,
  };
  analyzify.log('GTM_CONFIG:', GTM_CONFIG, 'an_gtm', 'init');

  const shouldIncludeNavdetail = (eventType) => {
    const isCollectionOrPage = window.analyzify.shopify_template === "collection" || window.analyzify.shopify_template === "page";
    const isNotWishlist = !window.location.pathname.includes('/pages/your-wishlist');
    
    const isPageloadOrNavClick = eventType === 'pageload' || eventType === 'ee_nav_click';
    
    return isCollectionOrPage && isNotWishlist && isPageloadOrNavClick;
  };

  const getNavdetail = (eventType) => {
    const shouldInclude = shouldIncludeNavdetail(eventType);
    const navDetailFromStorage = sessionStorage.getItem('azfy_navDetail');

    
    return shouldInclude ? (navDetailFromStorage || null) : null;
  };

  // Helper function to get device type for all events
  const getDeviceType = () => {
    return window.innerWidth >= 768 ? 'desktop' : 'mobile';
  };

  // Helper function to get comprehensive environment information
  window.analyzify.getEnvironmentInfo = () => {
    try {
      const ua = navigator.userAgent;
      
      // Browser detection
      const getBrowserInfo = () => {
        if (ua.includes('Chrome') && !ua.includes('Chromium') && !ua.includes('Edg')) {
          return { name: 'Chrome', engine: 'Blink' };
        } else if (ua.includes('Firefox')) {
          return { name: 'Firefox', engine: 'Gecko' };
        } else if (ua.includes('Safari') && !ua.includes('Chrome')) {
          return { name: 'Safari', engine: 'WebKit' };
        } else if (ua.includes('Edg')) {
          return { name: 'Edge', engine: 'Blink' };
        } else if (ua.includes('Opera') || ua.includes('OPR')) {
          return { name: 'Opera', engine: 'Blink' };
        } else {
          return { name: 'Unknown', engine: 'Unknown' };
        }
      };

      // OS detection
      const getOSInfo = () => {
        if (ua.includes('Windows')) return 'Windows';
        if (ua.includes('Mac OS X') || ua.includes('macOS')) return 'macOS';
        if (ua.includes('Linux')) return 'Linux';
        if (ua.includes('Android')) return 'Android';
        if (ua.includes('iPhone') || ua.includes('iPad')) return 'iOS';
        return 'Unknown';
      };

      const browser = getBrowserInfo();
      
      return {
        device_type: getDeviceType(),
        browser_name: browser.name,
        browser_engine: browser.engine,
        operating_system: getOSInfo(),
        screen_resolution: `${screen.width}x${screen.height}`,
        viewport_size: `${window.innerWidth}x${window.innerHeight}`,
        pixel_ratio: window.devicePixelRatio || 1,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        language: navigator.language,
        languages: navigator.languages?.join(',') || navigator.language,
        online_status: navigator.onLine,
        connection_type: navigator.connection?.effectiveType || 'unknown',
        cookie_enabled: navigator.cookieEnabled,
        java_enabled: navigator.javaEnabled?.() || false,
        touch_support: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
        user_agent: ua
      };
    } catch (error) {
      console.error('Error getting environment info:', error);
      return {
        device_type: getDeviceType(),
        browser_name: 'Unknown',
        error: 'Failed to detect environment'
      };
    }
  };

  window.analyzify.initGTM = (gtmObj, gtmProps) => {
    if(!gtmObj || !gtmProps) {
      console.warn('initGTM called with missing gtmObj or gtmProps:', gtmObj, gtmProps);
      return;
    }
    analyzify.log('initGTM called with:', gtmObj, gtmProps, 'an_gtm', 'initGTM');
    
    // Parameters for ecommerce object (technical/implementation details only)
    const params = {
      analyzify_source: 'theme',
      implementation_type: 'snippet'
    };
    
    // Enhanced parameters flag
    const enhanced_params = gtmProps?.enhanced_params || GTM_CONFIG.enhanced_params;
    analyzify.log('enhanced_params:', enhanced_params, 'an_gtm', 'initGTM');
    if (window.analyzify && window.analyzify.log) {
      window.analyzify.log('GTM enhanced_params', 'an_gtm', 'initGTM');
    } else {
      console.warn('analyzify.log not available at enhanced_params log');
    }
    const PAGE_TYPES = {
      'index': 'homepage',
      'collection': 'plp',
      'product': 'product',
      'cart': 'basket',
      'search': 'searchresults'
    };

    const pushedPage = PAGE_TYPES[window.analyzify.shopify_template] || 'other';
    if (window.analyzify && window.analyzify.log) {
      window.analyzify.log('GTM pushedPage', 'an_gtm', 'initGTM');
    } else {
      console.warn('analyzify.log not available at pushedPage log');
    }
    
    const userData = window.analyzify?.shopify_customer?.type === 'visitor'
      ? { type: 'visitor' }
      : {
          ...window.analyzify?.shopify_customer,
          email: window.analyzify?.shopify_customer?.email_address || null,
          phone: window.analyzify?.shopify_customer?.phone_number || null
        };
    analyzify.log('userData:', userData, 'an_gtm', 'initGTM');
    if (window.analyzify && window.analyzify.log) {
      window.analyzify.log('GTM userData', 'an_gtm', 'initGTM');
    } else {
      console.warn('analyzify.log not available at userData log');
    }
    const market = window.analyzify.market || window.analyzify.cookieStorage?.get('azfy_market');
    analyzify.log('window.analyzify.market:', window.analyzify.market, 'an_gtm', 'initGTM');

    const shop = window.analyzify.shop || window.analyzify.cookieStorage?.get('azfy_shop');
    analyzify.log('market:', market, 'an_gtm', 'initGTM');
    analyzify.log('shop:', shop, 'an_gtm', 'initGTM');
    if (window.analyzify && window.analyzify.log) {
      window.analyzify.log('GTM market', 'an_gtm', 'initGTM');
      window.analyzify.log('GTM shop', 'an_gtm', 'initGTM');
    } else {
      console.warn('analyzify.log not available at market/shop log');
    }

    // Page-load based events
    // View item list
    window.analyzify.gtmViewItemList = (title, id, handle, products) => {
      window.dataLayer.push({ ecommerce: null });
      
      const pageEventParams = window.analyzify.pageEventParams || {};
      const eventLocation = window.analyzify.buildEventLocation(handle, window.analyzify.shopify_template);

      const navdetail = getNavdetail('pageload');

      const items = products.map((item, index) => {
        const firstVariant = window.analyzify.getFirstVariant(item);
        const compareAtPrice = window.analyzify.formatPrice(item?.compare_at_price);
        const actualPrice = window.analyzify.formatPrice(firstVariant?.price ?? item?.price);
        const getDiscount = (compareAtPrice > 0 && compareAtPrice !== actualPrice) ? compareAtPrice - actualPrice : 0;
        const item_id = item?.id?.toString();
        const itemSpecificProps = window.analyzify?.itemProps?.[item_id];
        const itemObj = {
          ...window.analyzify.breadcrumbCategoriesItem,
          id: item?.handle || null,
          item_id: item?.handle || null,
          item_name: item?.title?.trim() || null,
          item_list_name: title?.trim() || null,
          category_id: id?.toString() || null,
          item_list_handle: handle || null,
          index: index,
          item_barcode: firstVariant?.barcode || null,
          discount: window.analyzify.formatPrice(getDiscount) || 0,
          price: actualPrice || 0,
          currency: window.analyzify?.currency || null,
          item_category: item?.type || null,
          item_brand: item?.vendor?.trim() || null,
          item_variant: firstVariant?.title?.trim() || null,
          item_variant_id: firstVariant?.id?.toString() || null,
          item_sku: item?.handle || null,
          quantity: 1,
          ...(enhanced_params ? {
            taxonomy_id: item?.taxonomy?.id || null,
            taxonomy_name: item?.taxonomy?.name || null,
            taxonomy_ancestors: item?.taxonomy?.ancestors || null,
            tags: item?.tags?.join(',') || null,
            options: item?.options?.join(',') || null,
            variant_ids: item?.variants?.map((v) => {
              return v?.id?.toString() || null;
            }).join(',') || null,
          } : {}),
        };
        
        return {
          ...itemObj,
          ...itemSpecificProps
        };
      });
    
      const chunkSize = gtmObj?.chunk_size || 25;
    
      if(gtmProps?.multiple_view_item_list || GTM_CONFIG.multiple_view_item_list) {
        const itemsChunks = items.length > chunkSize ? 
        items.map((item, index) => ({
          ...item,
          index: index
        })).reduce((resultArray, item, index) => { 
          const chunkIndex = Math.floor(index/chunkSize);
          if(!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
          }
          resultArray[chunkIndex].push(item);
          return resultArray;
        }, []) : [items.map((item, index) => ({
          ...item,
          index: index
        }))];

                 itemsChunks.forEach((chunk, chunkIndex) => {
           window.dataLayer.push({
             event: "ee_view_item_list",
             ss_event_id: window.analyzify.eventId?.reset('view_item_list') || null,
             category_id: id || null,
             ecommerce: {
               ...params,
               item_list_name: title || handle || null,
               items: chunk,
               cart_id: window.analyzify?.cart_id || null,
             },
             ...pageEventParams,
             shop_locale: shop?.locale || null,
             shop_country: shop?.country || null,
             market_country: market?.country || null,
             market_language: market?.language || null,
             event_location: eventLocation || null,
             device_type: getDeviceType(),
             ...window.analyzify.breadcrumbCategories,
             navdetail,
           });

         });
             } else {
         window.dataLayer.push({
           event: "ee_view_item_list",
           ss_event_id: window.analyzify.eventId?.reset('view_item_list') || null,
           ecommerce: {
             ...params,
             item_list_name: title || handle || null,
             category_id: id || null,
             items: items,
             cart_id: window.analyzify?.cart_id || null,
           },
           shop_locale: shop?.locale || null,
           shop_country: shop?.country || null,
           market_country: market?.country || null,
           market_language: market?.language || null,
           event_location: eventLocation || null,
           device_type: getDeviceType(),
           shop_country: shop?.country || null,
           market_country: market?.country || null,
           market_language: market?.language || null,
                    ...window.analyzify.breadcrumbCategories,
         navdetail,
       });

       }
    };

    // View item
    window.analyzify.gtmViewItem = (productObj, variantId) => {
      try {
        if (!productObj) return analyzify.log("Product object is not found", 'an_gtm', 'gtmViewItem');

        const {
          product,
          collection,
          taxonomy,
          variant
        } = productObj;

        if(!product) return analyzify.log('Product object is not found', 'an_gtm', 'gtmViewItem');
        const eventLocation = window.analyzify.buildEventLocation(product?.handle, window.analyzify.shopify_template);

        const navdetail = getNavdetail('pageload');

        const variantInput = variantId || variant?.id || window.analyzify?.getCurrentVariant()?.id;
        const variantDetails = window.analyzify.getVariantDetails(product?.variants, variantInput);
        const compareAtPrice = variantDetails?.compare_at_price;
        const actualPrice = window.analyzify.formatPrice(product?.price) ?? variantDetails?.price;
        const getDiscount = (compareAtPrice > 0 && compareAtPrice !== actualPrice) ? compareAtPrice - actualPrice : 0;
        const pageEventParams = window.analyzify.pageEventParams || {};
        window.dataLayer.push({ ecommerce: null });
        const item_id = product?.id?.toString();
        const itemSpecificProps = window.analyzify?.itemProps?.[item_id];

        const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
      const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
      const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
      const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);

        const urlParams = new URLSearchParams(window.location.search);
        const personalizedParams = {};
        let hasPersonalizedParams = false;
        
        if (urlParams.has('pr_rec_pid')) {
          personalizedParams.pr_rec_pid = urlParams.get('pr_rec_pid');
          hasPersonalizedParams = true;
        }
        
        if (urlParams.has('pr_rec_id')) {
          personalizedParams.pr_rec_id = urlParams.get('pr_rec_id');
          hasPersonalizedParams = true;
        }
        
        if (urlParams.has('pr_ref_pid')) {
          personalizedParams.pr_ref_pid = urlParams.get('pr_ref_pid');
          hasPersonalizedParams = true;
        }
        
        if (urlParams.has('pr_prod_strat')) {
          personalizedParams.pr_prod_strat = urlParams.get('pr_prod_strat');
          hasPersonalizedParams = true;
        }
        
        if (urlParams.has('pr_seq')) {
          personalizedParams.pr_seq = urlParams.get('pr_seq');
          hasPersonalizedParams = true;
        }
        
        if (hasPersonalizedParams) {
          personalizedParams.personalized_rec = true;
          window.analyzify.log('🎯 Personalized recommendation URL parameters detected for view_item', 'an_gtm', 'personalized_rec');
          window.analyzify.log('Personalized parameters: ' + JSON.stringify(personalizedParams), 'an_gtm', 'personalized_rec');
        }

                 window.dataLayer.push({
           event: "ee_view_item",
           ss_event_id: window.analyzify.eventId?.reset('view_item') || null,
           
           ecommerce: {
             ...params,
             currency: window.analyzify?.currency,
             value: window.analyzify.formatPrice(variantDetails?.price, false),
             cart_id: window.analyzify?.cart_id || null,
             items: [{
               id: product?.handle || null,
               product_type: product?.type || null,
               item_id: product?.handle || null,
               item_name: product?.title?.trim() || null,
               item_list_name: collection?.title?.trim() || null,
               category_id: collection?.id || null,
               item_list_handle: collection?.handle || null,
               price: window.analyzify.formatPrice(variantDetails?.price || product?.price, false),
               currency: window.analyzify?.currency || null,
               item_category: product?.type || null,
               ...window.analyzify.breadcrumbCategoriesItem,
               item_brand: product?.vendor || null,
               item_barcode: variantDetails?.barcode || null,
               discount: window.analyzify.formatPrice(getDiscount, false) || 0,
               item_variant: variantDetails?.title || null,
               item_variant_id: variantInput?.toString() || variantDetails?.id || null,
               item_sku: product?.handle || null,
               quantity: 1,
               ...(enhanced_params ? {
                 tags: product?.tags?.join(',') || null,
                 options: product?.options?.join(',') || null,
                 variant_ids: product?.variants?.map((v) => v?.id?.toString() || null).join(',') || null,
                 taxonomy_id: taxonomy?.id || null,
                 taxonomy_name: taxonomy?.name || null,
                 taxonomy_ancestors: taxonomy?.ancestors || null,
               } : {}),
               ...(itemSpecificProps || {})
             }],
           },
           shop_locale: shop?.locale || null,
           shop_country: shop?.country || null,
           market_country: market?.country || null,
           market_language: market?.language || null,
           event_location: eventLocation || null,
           cart_quantities: cartQuantities,
           cart_sizes: cartSizes,
           cart_skus: cartSkus,
           cart_units: cartUnits,
           ...window.analyzify.breadcrumbCategories,
           ...pageEventParams,
           navdetail,
           device_type: getDeviceType(),
           ...(hasPersonalizedParams ? personalizedParams : {}),
         });
         


      } catch (error) {
        console.error("Error processing product view:", error);
      }
    };

    // View wishlist
    window.analyzify.gtmViewWishlist = (products) => {
      try {
        analyzify.log('gtmViewWishlist triggered', 'an_gtm', 'gtmViewWishlist');
        
        const pageEventParams = window.analyzify.pageEventParams || {};
        const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
        const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
        const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
        const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);
        
        const items = (products || []).map((item, index) => {
          try {
            const firstVariant = window.analyzify.getFirstVariant(item);
            return {
              id: item?.handle || null,
              item_id: item?.handle || null,
              item_name: item?.product_title?.trim() || item?.title?.trim() || null,
              item_list_name: "Wishlist",
              category_id: null,
              position: index + 1,
              price: window.analyzify.formatPrice(item?.price, true),
              currency: window.analyzify?.currency || null,
              item_category: item?.product_type || item?.type || null,
              item_brand: item?.vendor || null,
              item_variant: firstVariant?.title?.trim() || null,
              item_variant_id: firstVariant?.id?.toString() || null,
              item_sku: item?.handle || null,
              quantity: item?.quantity || 1,
              ...(enhanced_params ? {
                tags: item?.tags?.join(',') || null,
                options: item?.options?.join(',') || null,
              } : {})
            };
          } catch (error) {
            console.error('Error processing wishlist item:', error);
            return null;
          }
        }).filter(item => item !== null);

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "ee_view_wishlist",
          ss_event_id: window.analyzify.eventId?.reset('view_wishlist') || null,
          page_type: "wishlist",
          cart_id: window.analyzify?.cart_id || null,
          ecommerce: {
            ...params,
            currency: window.analyzify?.currency,
            wishlist_items_count: items.length,
            items: items,
          },
          shop_locale: shop?.locale || null,
          shop_country: shop?.country || null,
          market_country: market?.country || null,
          market_language: market?.language || null,
          cart_quantities: cartQuantities,
          cart_sizes: cartSizes,
          cart_skus: cartSkus,
          cart_units: cartUnits,
          device_type: getDeviceType(),
          ...pageEventParams,
        });
        
        analyzify.log('Wishlist view event sent', 'an_gtm', 'gtmViewWishlist');
        console.log('gtmViewWishlist triggered with', items.length, 'items');
        
      } catch (error) {
        analyzify.log('Error in gtmViewWishlist', 'an_gtm', 'gtmViewWishlist');
        console.error('gtmViewWishlist error:', error);
      }
    };

    // View account
    window.analyzify.gtmViewAccount = () => {
      try {
        analyzify.log('gtmViewAccount triggered', 'an_gtm', 'gtmViewAccount');
        
        // Get account object with customer data
        const accountObj = window.analyzify.getAccountObj || null;
        const customer = accountObj?.customer || null;
        
        // Build customer parameters object
        const customerParams = {
          // Basic customer info
          customer_id: customer?.id || null,
          customer_email: customer?.email || null,
          customer_first_name: customer?.first_name || null,
          customer_last_name: customer?.last_name || null,
          customer_name: customer?.name || null,
          customer_phone: customer?.phone || null,
          // Account status
          customer_orders_count: customer?.orders_count || null,
          customer_total_spent: customer?.total_spent || null,
          customer_accepts_marketing: customer?.accepts_marketing || null,
          customer_has_account: customer?.has_account || null,
          customer_has_avatar: customer?.has_avatar || null,
          customer_tax_exempt: customer?.tax_exempt || null,
          customer_addresses_count: customer?.addresses_count || null,
          customer_tags: customer?.tags ? customer.tags.join(',') : null,
          // B2B information
          customer_b2b: customer?.b2b || null,
          customer_company_id: customer?.current_company?.id || null,
          customer_company_name: customer?.current_company?.name || null,
          customer_current_location_id: customer?.current_location?.id || null,
          customer_current_location_name: customer?.current_location?.name || null,
          customer_company_locations_count: customer?.company_available_locations_count || null,
          // Default address information
          customer_default_address_id: customer?.default_address?.id || null,
          customer_city: customer?.default_address?.city || null,
          customer_province: customer?.default_address?.province || null,
          customer_province_code: customer?.default_address?.province_code || null,
          customer_country: customer?.default_address?.country || null,
          customer_country_code: customer?.default_address?.country_code || null,
          customer_zip: customer?.default_address?.zip || null,
          customer_address1: customer?.default_address?.address1 || null,
          customer_address2: customer?.default_address?.address2 || null,
          customer_address_company: customer?.default_address?.company || null,
          customer_address_phone: customer?.default_address?.phone || null,
          // Last order information
          customer_last_order_id: customer?.last_order?.id || null,
          customer_last_order_number: customer?.last_order?.order_number || null,
          customer_last_order_name: customer?.last_order?.name || null,
          customer_last_order_total: customer?.last_order?.total_price || null,
          customer_last_order_date: customer?.last_order?.created_at || null,
          customer_last_order_financial_status: customer?.last_order?.financial_status || null,
          customer_last_order_fulfillment_status: customer?.last_order?.fulfillment_status || null,
          customer_last_order_currency: customer?.last_order?.currency || null,
          customer_last_order_items_count: customer?.last_order?.item_count || null,
          // Store credit information
          customer_store_credit_balance: customer?.store_credit_account?.balance || null,
          customer_store_credit_currency: customer?.store_credit_account?.currency || null,
          // Summary counts for arrays
          customer_payment_methods_count: customer?.payment_methods?.length || 0,
          customer_orders_history_count: customer?.orders?.length || 0,
          customer_addresses_list_count: customer?.addresses?.length || 0,
        };

        
        const pageEventParams = window.analyzify.pageEventParams || {};
        const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
        const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
        const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
        const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);
        const eventLocation = window.analyzify.buildEventLocation(null, window.analyzify.shopify_template);

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "ee_view_account",
          ss_event_id: window.analyzify.eventId?.reset('view_account') || null,
          page_type: "account",
          cart_id: window.analyzify?.cart_id || null,
          ...customerParams,
          ecommerce: {
            ...params,
            currency: window.analyzify?.currency,
          },
          shop_locale: shop?.locale || null,
          shop_country: shop?.country || null,
          market_country: market?.country || null,
          market_language: market?.language || null,
          event_location: eventLocation || null,
          cart_quantities: cartQuantities,
          cart_sizes: cartSizes,
          cart_skus: cartSkus,
          cart_units: cartUnits,
          device_type: getDeviceType(),
          ...window.analyzify.breadcrumbCategories,
          ...pageEventParams,
        });
        
        analyzify.log('Account view event sent', 'an_gtm', 'gtmViewAccount');
        
      } catch (error) {
        analyzify.log('Error in gtmViewAccount', 'an_gtm', 'gtmViewAccount');
        console.error('gtmViewAccount error:', error);
      }
    };

    // Click-based events
    // Variant change
    // for wishlist page variant trigger we can't scrape the page and since the 
    // variant id is not included in neither the dom nor swym data we can't access variant-id. Other fields we
    // retrieve by matching the product name of the clicked element with the wishlist data from the local storage
    window.analyzify.gtmVariantChange = (variantData) => {
      try {
        const commonData = {
          pageEventParams: window.analyzify.pageEventParams || {},
          cartQuantities: window.analyzify.getCart.quantities(window.analyzify?.detectedCart),
          cartSizes: window.analyzify.getCart.sizes(window.analyzify?.detectedCart),
          cartSkus: window.analyzify.getCart.skus(window.analyzify?.detectedCart),
          cartUnits: window.analyzify.getCart.units(window.analyzify?.detectedCart)
        };

        // Template-based routing
        if (variantData.swym_product || (variantData.epi && variantData.empi)) {
          handleWishlistVariantChange(variantData, commonData);
        } else {
          handleStandardVariantChange(variantData, commonData);
        }

      } catch (error) {
        analyzify.log('Error in gtmVariantChange: ' + error.message, 'an_gtm', 'gtmVariantChange');
      }
    };

    // Wishlist variant change handler
    const handleWishlistVariantChange = (variantData, commonData) => {
      const swymProduct = variantData.swym_product || variantData;
      const clickedSize = variantData.clicked_size;
      const currentColor = swymProduct.vi ? swymProduct.vi.split('/')[1] : null;
      const newVariantTitle = currentColor ? `${clickedSize}/${currentColor}` : clickedSize;
      const eventLocation = window.analyzify.buildEventLocation(null, "wishlist");

      window.dataLayer.push({
        event: "ee_variant_changed",
        ss_event_id: window.analyzify.eventId?.reset('variant_changed') || null,
        variant_id: null,
        variant_title: newVariantTitle,
        product_price: window.analyzify.formatPrice(swymProduct.pr, false),
        product_sku: swymProduct.sku || null,
        product_id: swymProduct.empi?.toString() || null,
        product_title: swymProduct.dt || null,
        cart_id: window.analyzify?.cart_id || null,
        variant_availability: true,
        category_id: null,
        shop_locale: shop?.locale || null,
        shop_country: shop?.country || null,
        market_country: market?.country || null,
        market_language: market?.language || null,
        event_location: eventLocation || null,
        ...window.analyzify.breadcrumbCategories,
        cart_quantities: commonData.cartQuantities,
        cart_sizes: commonData.cartSizes,
        cart_skus: commonData.cartSkus,
        cart_units: commonData.cartUnits,
        ...commonData.pageEventParams,
        device_type: getDeviceType(),
        // Wishlist-specific data
        source: variantData.source || 'wishlist_variant_change',
      });

      analyzify.log('Wishlist variant change event sent', 'an_gtm', 'gtmVariantChange');
    };

    // Product status event handler
    window.analyzify.gtmProductStatus = (product, variantResult, sourceContext, commonData, status = 'out_of_stock') => {
      try {
        const eventLocation = window.analyzify.buildEventLocation(product?.handle, window.analyzify.shopify_template);
        
        window.dataLayer.push({
          event: "ee_product_status",
          ss_event_id: window.analyzify.eventId?.reset('product_status') || null,
          product_id: product?.handle || null,
          item_id: product?.handle || null,
          id: product?.handle || null,
          product_title: product?.title || null,
          variant_id: variantResult.details?.id?.toString() || null,
          variant_title: variantResult.details?.title || null,
          variant_sku: variantResult.details?.sku || null,
          product_status: status,
          variant_availability: variantResult.variant?.available || false,
          product_price: window.analyzify.formatPrice(variantResult.details?.price, false),
          currency: window.analyzify?.currency || null,
          cart_id: window.analyzify?.cart_id || null,
          shop_locale: shop?.locale || null,
          shop_country: shop?.country || null,
          market_country: market?.country || null,
          market_language: market?.language || null,
          event_location: eventLocation || null,
          device_type: getDeviceType(),
          ...window.analyzify.breadcrumbCategories,
          cart_quantities: commonData.cartQuantities,
          cart_sizes: commonData.cartSizes,
          cart_skus: commonData.cartSkus,
          cart_units: commonData.cartUnits,
          ...commonData.pageEventParams,
          source: `product_status_${sourceContext}`
        });
        
        analyzify.log(`Product status event sent - ${status}`, 'an_gtm', 'gtmProductStatus');
        
      } catch (error) {
        analyzify.log('Error in gtmProductStatus: ' + error.message, 'an_gtm', 'gtmProductStatus');
      }
    };

    // Standard variant change(product/collection/search/homepage/page)
    const handleStandardVariantChange = (variantData, commonData) => {
      const templateHandlers = {
        product: () => ({ 
          product: window.analyzify.getProductObj?.product, 
          context: 'product' 
        }),
        collection: () => {
          if (!window.analyzify.getCollectionObj || !variantData.element) return null;
          const product = window.analyzify.findClickedProduct(variantData.element, window.analyzify.getCollectionObj.products);
          return product ? { product, context: 'collection' } : null;
        },
        search: () => {
          if (!window.analyzify.getSearchObj || !variantData.element) return null;
          
          // Try variant ID first
          if (variantData.variant_id) {
            for (const searchProduct of window.analyzify.getSearchObj.products || []) {
              if (searchProduct.variants) {
                for (const variant of searchProduct.variants) {
                  // Try multiple comparison methods to handle type mismatches
                  if (variant.id.toString() === variantData.variant_id.toString() || 
                      variant.id === variantData.variant_id ||
                      variant.id === parseInt(variantData.variant_id)) {
                    return { product: searchProduct, context: 'search' };
                  }
                }
              }
            }
          }
          
          // Fallback to findClickedProduct
          const product = window.analyzify.findClickedProduct(variantData.element, window.analyzify.getSearchObj.products);
          return product ? { product, context: 'search' } : null;
        },
        async_page: async () => {
          if (!variantData.element || !typeof window.analyzify.getPageProducts === 'function') return null;
          
          const pageProducts = await window.analyzify.getPageProducts();
          const products = pageProducts?.products || [];
          const context = variantData.source?.includes('homepage') ? 'homepage' : 'page';
          
          // Try dataset variant ID first
          if (variantData.element?.dataset?.variantId) {
            const variantId = variantData.element.dataset.variantId;
            const product = products.find(p => Array.isArray(p?.variants) && p.variants.some(v => Number(v?.id) === Number(variantId)));
            if (product) return { product, context };
          }
          
          // Fallback to findClickedProduct
          const product = window.analyzify.findClickedProduct(variantData.element, products);
          return product ? { product, context } : null;
        }
      };

      // Determine template and get product
      let productData = null;
      
      if (window.analyzify.getProductObj?.product) {
        productData = templateHandlers.product();
      } else if (window.analyzify.getCollectionObj && variantData.element) {
        productData = templateHandlers.collection();
      } else if (window.analyzify.getSearchObj && variantData.element) {
        productData = templateHandlers.search();
      } else if (variantData.element && (variantData.source?.includes('homepage') || variantData.source?.includes('page'))) {
        // Handle async page products
        templateHandlers.async_page().then(productData => {
          if (productData) {
            processVariantChange(productData.product, productData.context, variantData, commonData);
          } else {
            analyzify.log('Product not found in page products', 'an_gtm', 'gtmVariantChange');
          }
        });
        return; // Exit early for async handling
      }

      if (!productData?.product) {
        return analyzify.log('Product not found in any template context', 'an_gtm', 'gtmVariantChange');
      }

      processVariantChange(productData.product, productData.context, variantData, commonData);
    };

    // Variant processing logic
    const processVariantChange = (product, sourceContext, variantData, commonData) => {
      const variantResult = getSelectedVariant(product, variantData);
      
      if (!variantResult.variant || !variantResult.details) {
        return analyzify.log('Variant or variant details not found', 'an_gtm', 'gtmVariantChange');
      }

      const eventLocation = window.analyzify.buildEventLocation(product?.handle, window.analyzify.shopify_template);
      const isAvailable = variantResult.variant?.available || false;

      window.dataLayer.push({
        event: "ee_variant_changed",
        ss_event_id: window.analyzify.eventId?.reset('variant_changed') || null,
        variant_id: variantResult.details?.id?.toString() || null,
        variant_title: variantResult.details?.title || null,
        product_price: window.analyzify.formatPrice(variantResult.details?.price, false),
        product_sku: variantResult.details?.sku || null,
        product_id: product?.id || null,
        id: product?.handle || null,
        item_id: product?.handle || null,
        product_title: product?.title || null,
        cart_id: window.analyzify?.cart_id || null,
        variant_availability: isAvailable,
        category_id: (sourceContext === 'search' ? gtmObj.getSearchObj?.id : gtmObj.getCollectionObj?.id) || null,
        shop_locale: shop?.locale || null,
        shop_country: shop?.country || null,
        market_country: market?.country || null,
        market_language: market?.language || null,
        event_location: eventLocation || null,
        ...window.analyzify.breadcrumbCategories,
        cart_quantities: commonData.cartQuantities,
        cart_sizes: commonData.cartSizes,
        cart_skus: commonData.cartSkus,
        cart_units: commonData.cartUnits,
        ...commonData.pageEventParams,
        device_type: getDeviceType(),
        // Add source context
        source: variantData.source || sourceContext + '_variant_change',
        clicked_size: variantData.clicked_size || null
      });

      // Send product status event for product page when variant is out of stock
      if (sourceContext === 'product' && !isAvailable) {
        window.analyzify.gtmProductStatus(product, variantResult, sourceContext, commonData, 'out_of_stock');
      }

      // Optional view item trigger
      if (gtmObj?.variant_changed_with_view_item || false) {
        if (sourceContext === 'product') {
          window.analyzify.gtmViewItem(gtmObj.getProductObj, variantResult.variant?.id);
        }
      }

      analyzify.log(`${sourceContext} variant change event sent`, 'an_gtm', 'gtmVariantChange');
    };

    // Variant selection logic
    const getSelectedVariant = (product, variantData) => {
      const methods = {
        elementDataset: () => {
          const variantId = variantData.element?.dataset?.variantId;
          return variantId ? product?.variants?.find(v => v.id.toString() === variantId.toString()) : null;
        },
        id: () => product?.variants?.find(v => v.id.toString() === variantData.id.toString()),
        variant_id: () => product?.variants?.find(v => v.id.toString() === variantData.variant_id.toString()),
        clicked_size: () => product?.variants?.find(variant => {
          const size = variantData.clicked_size?.toLowerCase();
          return variant.title?.toLowerCase().includes(size) ||
                 variant.option1?.toLowerCase() === size ||
                 variant.option2?.toLowerCase() === size ||
                 variant.option3?.toLowerCase() === size;
        })
      };

      let selectedVariant = null;
      
      // Priority order for variant detection
      if (variantData.element?.dataset?.variantId) selectedVariant = methods.elementDataset();
      else if (variantData.id) selectedVariant = methods.id();
      else if (variantData.variant_id) selectedVariant = methods.variant_id();
      else if (variantData.clicked_size) selectedVariant = methods.clicked_size();

      return {
        variant: selectedVariant,
        details: selectedVariant ? window.analyzify.getVariantDetails(product?.variants, selectedVariant.id) : null
      };
    };

    // Select item
    window.analyzify.gtmSelectItem = (productObject, clickedElement = null) => {
      if (!productObject) return analyzify.log("Product object is not found", 'an_gtm', 'gtmSelectItem');

      // Handle both structured and direct product objects
      let productObj, taxonomy, collection, variant;
      
      if (productObject.product) {
        // Structured object with product property
        ({ product: productObj, taxonomy, collection, variant } = productObject);
      } else {
        // Direct product object
        productObj = productObject;
        taxonomy = null;
        collection = null;
        variant = null;
      }

      // Ensure productObj exists after assignment
      if (!productObj) return analyzify.log("Product object is not valid", 'an_gtm', 'gtmSelectItem');

      const pageEventParams = window.analyzify.pageEventParams || {};

      analyzify.log('productObj: gtmSelectItem', 'an_gtm', 'gtmSelectItem');
      analyzify.log(productObject, 'an_gtm', 'gtmSelectItem');

      // Check if the clicked element is within product recommendations container
      const isPersonalizedRecommendation = clickedElement && 
        clickedElement.closest('.product-recommendations-container') !== null;

      // Record product ID in sessionStorage if it's a personalized recommendation
      if (isPersonalizedRecommendation && productObj?.id) {
        try {
          sessionStorage.setItem('azfy_per_rec', productObj.id.toString());
          analyzify.log('Recorded personalized recommendation product ID: ' + productObj.id, 'an_gtm', 'gtmSelectItem');
        } catch (error) {
          analyzify.log('Error storing personalized recommendation ID in sessionStorage: ' + error.message, 'an_gtm', 'gtmSelectItem');
        }
      }

      const collectionObj = window.analyzify.getCollectionObj;
      const firstVariant = window.analyzify.getFirstVariant(productObj);
      const compareAtPrice = window.analyzify.formatPrice(productObj?.compare_at_price);
      const actualPrice = window.analyzify.formatPrice(productObj?.price ?? firstVariant?.price);
      const getDiscount = (compareAtPrice > 0 && compareAtPrice !== actualPrice) ? compareAtPrice - actualPrice : 0;

      window.dataLayer.push({ ecommerce: null });

      const item_id = productObj?.id?.toString();
      const eventLocation = window.analyzify.buildEventLocation(productObj.handle, window.analyzify.shopify_template);

      const itemSpecificProps = window.analyzify?.itemProps?.[item_id];

      const itemObj = {
        event: "ee_select_item",
        ss_event_id: window.analyzify.eventId?.reset('select_item') || null,
        ecommerce: {
          ...params,
          currency: window.analyzify.currency,
          value: window.analyzify.formatPrice(productObj?.price, true),
          cart_id: window.analyzify?.cart_id || null,
          items: [{
            id: productObj?.handle || null,
            item_id: productObj?.handle || null,
            item_name: productObj?.title?.trim() || null,
            item_list_name: collection?.title || collectionObj?.title || null,
            category_id: collection?.id || collectionObj?.id || null,
            item_list_handle: collection?.handle || collectionObj?.handle || null,
            item_barcode: firstVariant?.barcode || null,
            discount: window.analyzify.formatPrice(getDiscount, false) || 0,
            price: window.analyzify.formatPrice(firstVariant?.price || productObj?.price, true),
            currency: window.analyzify?.currency || null,
            item_category: productObj?.product_type || productObj?.type || null,
            item_brand: productObj?.vendor?.trim() || null,
            item_variant: firstVariant?.title?.trim() || null,
            item_variant_id: firstVariant?.id?.toString() || null,
            item_sku: productObj?.handle || null,
            quantity: 1,
            ...(enhanced_params ? {
              taxonomy_id: taxonomy?.id || null,
              taxonomy_name: taxonomy?.name || null,
              taxonomy_ancestors: taxonomy?.ancestors || null,
              tags: productObj?.tags?.join(',') || null,
              options: productObj?.options?.join(',') || null,
              variant_ids: productObj?.variants?.map((v) => v?.id?.toString() || null).join(',') || null,
            } : {}),
            ...(itemSpecificProps || {})
          }]
        },
                 shop_locale: shop?.locale || null,
         shop_country: shop?.country || null,
         market_country: market?.country || null,
         market_language: market?.language || null,
         event_location: eventLocation || null,
         ...pageEventParams,
         ...window.analyzify.breadcrumbCategories,
         device_type: getDeviceType(),
         ...(isPersonalizedRecommendation ? { personalized_rec: true } : {})
      };

             window.dataLayer.push(itemObj);
       
       console.log(JSON.stringify(window.dataLayer), 'an_gtm', 'gtmSelectItem');
    };

    // Add to cart
    window.analyzify.gtmAddToCart = (productObj, currentVariant, quantityIncrease = false) => {
      try {
        if (!productObj) return analyzify.log("Product object is not found", 'an_gtm', 'gtmAddToCart');
        const pageEventParams = window.analyzify.pageEventParams || {};
  
        window.dataLayer.push({ ecommerce: null });

        let { product, variant, collection, taxonomy } = productObj;

        if(!product) product = productObj;
        
        const eventLocation = window.analyzify.buildEventLocation(product?.handle, window.analyzify.shopify_template);
        const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
        const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
        const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
        const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);

        const prodQty = productObj.quantity || window.analyzify.findQuantity() || 1;
        const addedItem = (() => {
          try {
            const variantDetails = window.analyzify.getVariantDetails(product?.variants, currentVariant || variant?.id);
            const compareAtPrice = variantDetails?.compare_at_price || product?.compare_at_price || 0;
            const actualPrice = variantDetails?.price || window.analyzify.formatPrice(product?.price) || 0;
            const getDiscount = (compareAtPrice > 0 && compareAtPrice !== actualPrice) ? compareAtPrice - actualPrice : 0;
            
            const item_id = product?.id?.toString();
            const itemSpecificProps = window.analyzify?.itemProps?.[item_id];

            const itemObj = {
              id: product?.handle || null,
              item_id: product?.handle || null,
              item_name: product?.title?.trim() || null,
              price: variantDetails?.price || window.analyzify.formatPrice(product?.price) || 0,
              discount: window.analyzify.formatPrice(getDiscount) || 0,
              item_barcode: variantDetails?.barcode || null,
              currency: window.analyzify?.currency || null,
              item_category: product?.type || null,
              item_brand: product?.vendor?.trim() || null,
              quantity: prodQty || 1,
              item_variant: variantDetails?.title || null,
              item_variant_id: (variantDetails?.id || variant?.id).toString() || null,
              item_sku: product?.handle || null,
              ...window.analyzify.breadcrumbCategoriesItem,
              index: 0,
              ...(enhanced_params ? {
                taxonomy_id: taxonomy?.id || null,
                taxonomy_name: taxonomy?.name || null,
                taxonomy_ancestors: taxonomy?.ancestors || null,
                tags: product?.tags?.join(',') || null,
                options: product?.options?.join(',') || null,
                variant_ids: product?.variants?.map((v) => {
                  return v?.id?.toString() || null;
                }).join(',') || null,
              } : {}),
              ...(itemSpecificProps || {})
            };
            return itemObj;

          } catch (error) {
            console.error("Error processing product add to cart:", error);
          }
        })();

         const totalVal = parseFloat(((addedItem.price || 0) * (prodQty || 1)).toFixed(2));

        if (collection) addedItem.item_list_id = collection?.id || null;
        if (collection?.title) addedItem.item_list_name = collection?.title || null;

        const eventName = quantityIncrease ? "ee_quantity_increased" : "ee_add_to_cart";

      const _eventData = {
        event: eventName,
        ss_event_id: window.analyzify.eventId?.reset('add_to_cart') || null,
        ecommerce: {
          ...params,
          currency: window.analyzify?.currency,
          value: window.analyzify.formatPrice(totalVal, false),
          cart_id: window.analyzify?.cart_id || null,
          items: [addedItem],
        },
        category_id: collection?.id || gtmObj.getCollectionObj?.id || null,
        shop_locale: shop?.locale || null,
        shop_country: shop?.country || null,
        event_location: eventLocation || null,
        market_country: market?.country || null,
        market_language: market?.language || null,
        ...pageEventParams,
        ...window.analyzify.breadcrumbCategories,

          cart_quantities: cartQuantities,
          cart_sizes: cartSizes,
          cart_skus: cartSkus,
          cart_units: cartUnits,
          device_type: getDeviceType(),
      };

        window.dataLayer.push(_eventData);
        
        // Store the added variant info for verification
        window.analyzify.lastAddedVariant = {
          variantId: (currentVariant || variant?.id || addedItem.item_variant_id),
          timestamp: Date.now(),
          productTitle: addedItem.item_name,
          quantity: prodQty
        };
        
        window.analyzify.updateDetectedCart();
        
          analyzify.log("Product ee_add_to_cart", 'an_gtm', 'gtmAddToCart');
      } catch (error) {
        console.error("Error processing product add to cart:", error);
      }
    };

    // Function to send cart validation event if added item is missing
    window.analyzify.gtmCartValidationFailed = (variantInfo, cartData) => {
      try {
        if (!variantInfo || !cartData) return;

        const pageEventParams = window.analyzify.pageEventParams || {};
        const envInfo = window.analyzify.getEnvironmentInfo();
        
        window.dataLayer.push({ ecommerce: null });

        const _eventData = {
          event: "ee_cart_validation_failed",
          ss_event_id: window.analyzify.eventId?.reset('cart_validation') || null,
          ecommerce: {
            ...params,
            currency: window.analyzify?.currency,
            cart_id: window.analyzify?.cart_id || null,
          },
          validation_details: {
            expected_variant_id: variantInfo.variantId?.toString(),
            product_title: variantInfo.productTitle,
            expected_quantity: variantInfo.quantity,
            cart_variant_ids: cartData.items?.map(item => item.variant_id?.toString()) || [],
            cart_total_items: cartData.item_count || 0,
            time_elapsed: Date.now() - variantInfo.timestamp,
            source: variantInfo.source || 'unknown'
          },
          environment_info: {
            device_type: envInfo.device_type,
            browser_name: envInfo.browser_name,
            browser_engine: envInfo.browser_engine,
            operating_system: envInfo.operating_system,
            screen_resolution: envInfo.screen_resolution,
            viewport_size: envInfo.viewport_size,
            pixel_ratio: envInfo.pixel_ratio,
            timezone: envInfo.timezone,
            language: envInfo.language,
            online_status: envInfo.online_status,
            connection_type: envInfo.connection_type,
            cookie_enabled: envInfo.cookie_enabled,
            touch_support: envInfo.touch_support
          },
          technical_details: {
            user_agent: envInfo.user_agent,
            referrer: document.referrer || null,
            page_url: window.location.href,
            page_title: document.title,
            timestamp: new Date().toISOString(),
            local_storage_available: typeof(Storage) !== "undefined",
            session_storage_available: typeof(sessionStorage) !== "undefined",
            cookies_available: navigator.cookieEnabled
          },
          shop_locale: shop?.locale || null,
          shop_country: shop?.country || null,
          market_country: market?.country || null,
          market_language: market?.language || null,
          ...pageEventParams
        };

        window.dataLayer.push(_eventData);
        
        analyzify.log("Cart validation failed - variant not found in cart", 'an_gtm', 'gtmCartValidationFailed');
        console.warn('Cart validation failed:', {
          expected: variantInfo,
          actual: cartData.items?.map(item => ({
            variant_id: item.variant_id,
            title: item.title,
            quantity: item.quantity
          })),
          environment: envInfo
        });
        
      } catch (error) {
        console.error("Error processing cart validation event:", error);
      }
    };

         // Add to wishlist
     window.analyzify.gtmAddToWishList = (productObj, currentVariant) => {
    
    
       if (!productObj) return analyzify.log("Product object is not found", 'an_gtm', 'gtmAddToWishList');

       window.dataLayer.push({ ecommerce: null });
       let { product, variant, collection, taxonomy } = productObj;
       if(!product) product = productObj;
      const firstVariant = window.analyzify.getFirstVariant(product);
      const variantDetails = window.analyzify.getVariantDetails(product?.variants, currentVariant || variant?.id || firstVariant?.id);

      const compareAtPrice = variantDetails?.compare_at_price;
      const actualPrice = variantDetails?.price || window.analyzify.formatPrice(product?.price) || 0;
      const getDiscount = (compareAtPrice > 0 && compareAtPrice !== actualPrice) ? compareAtPrice - actualPrice : 0;

      const item_id = product?.id?.toString();
      const itemSpecificProps = window.analyzify?.itemProps?.[item_id];

      const pageEventParams = window.analyzify.pageEventParams || {};
        const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
        const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
        const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
        const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);

      const eventLocation = window.analyzify.buildEventLocation(product?.handle, window.analyzify.shopify_template);
      
      const itemObj = {
        id: product?.handle || null,
        item_id: product?.handle || null,
        item_name: product?.title?.trim() || null,
        price: variantDetails?.price || window.analyzify.formatPrice(product?.price) || 0,
        currency: window.analyzify?.currency || null,
        item_category: product?.type || null,
        category_id: collection?.id || gtmObj.getCollectionObj?.id || null,
        discount: window.analyzify.formatPrice(getDiscount) || 0,
        item_barcode: variantDetails?.barcode || null,
        item_brand: product?.vendor?.trim() || null,
        item_variant: variantDetails?.title?.trim() || null,
        item_variant_id: variantDetails?.id || null,
        item_sku: product?.handle || null,
        quantity: 1,
        index: 0,
        ...(enhanced_params ? {
          taxonomy_id: taxonomy?.id || null,
          taxonomy_name: taxonomy?.name || null,
          taxonomy_ancestors: taxonomy?.ancestors || null,
          tags: product?.tags?.join(',') || null,
          options: product?.options?.join(',') || null,
          variant_ids: product?.variants?.map((v) => {
            return v?.id?.toString() || null;
          }).join(',') || null,
        } : {}),
        ...(itemSpecificProps || {})
      };

      if(collection) itemObj.item_list_id = collection?.id || null;
      if(collection?.title) itemObj.item_list_name = collection?.title || null;

      if (!variantDetails) return analyzify.log("Variant details not found", 'an_gtm', 'gtmAddToWishList');



      itemObj.item_variant_id = variantDetails?.id || null;
      itemObj.price = window.analyzify.formatPrice(variantDetails?.price || 0);
      itemObj.item_sku = productObj?.handle || null;
      itemObj.item_variant = variantDetails?.title?.trim() || null;
      itemObj.item_name = productObj?.title?.trim() || null;

      const prodQty = analyzify.findQuantity() || 1;
      const totalVal = itemObj.price * prodQty;

             window.dataLayer.push({
         event: "ee_add_to_wishlist",
         ss_event_id: window.analyzify.eventId?.reset('add_to_wishlist') || null,
         ecommerce: {
           ...params,
           currency: window.analyzify.currency,
           value: window.analyzify.formatPrice(totalVal, false),
           cart_id: window.analyzify?.cart_id || null,
           items: [itemObj],
         },
         category_id: collection?.id || gtmObj.getCollectionObj?.id || null,
         shop_locale: shop?.locale || null,
         shop_country: shop?.country || null,
         market_country: market?.country || null,
         market_language: market?.language || null,
         ...pageEventParams,
         event_location: eventLocation || null,
         ...window.analyzify.breadcrumbCategories,
         cart_quantities: cartQuantities,
         cart_sizes: cartSizes,
         cart_skus: cartSkus,
         cart_units: cartUnits,
         device_type: getDeviceType(),

       });
       
      analyzify.log("Product ee_add_to_wishlist", 'an_gtm', 'gtmAddToWishList');
    };

    // Remove from wishlist (concise)
    window.analyzify.gtmRemoveFromWishList = (productObj, currentVariant) => {
      try {
        if (!productObj) return;

        window.dataLayer.push({ ecommerce: null });
        let { product, variant, collection, taxonomy } = productObj;
        if (!product) product = productObj;

        const firstVariant = window.analyzify.getFirstVariant(product);
        const variantDetails = window.analyzify.getVariantDetails(product?.variants, currentVariant || variant?.id || firstVariant?.id);

        const item_id = product?.id?.toString();
        const itemSpecificProps = window.analyzify?.itemProps?.[item_id];
        const eventLocation = window.analyzify.buildEventLocation(product?.handle, window.analyzify.shopify_template);

        const itemObj = {
          id: product?.handle || null,
          item_id: product?.handle || null,
          item_name: product?.title?.trim() || null,
          price: window.analyzify.formatPrice(variantDetails?.price || product?.price) || 0,
          currency: window.analyzify?.currency || null,
          item_category: product?.type || null,
          item_brand: product?.vendor?.trim() || null,
          item_variant: variantDetails?.title?.trim() || null,
          item_variant_id: variantDetails?.id || null,
          item_sku: product?.handle || null,
          category_id: collection?.id || gtmObj.getCollectionObj?.id || null,
          quantity: 1,
          index: 0,
          ...(enhanced_params ? {
            taxonomy_id: taxonomy?.id || null,
            taxonomy_name: taxonomy?.name || null,
            taxonomy_ancestors: taxonomy?.ancestors || null,
            tags: product?.tags?.join(',') || null,
            options: product?.options?.join(',') || null,
            variant_ids: product?.variants?.map((v) => v?.id?.toString() || null).join(',') || null,
          } : {}),
          ...(itemSpecificProps || {})
        };

        if (collection) itemObj.item_list_id = collection?.id || null;
        if (collection?.title) itemObj.item_list_name = collection?.title || null;

        const pageEventParams = window.analyzify.pageEventParams || {};

        const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
        const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
        const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
        const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);

        window.dataLayer.push({
           event: "ee_remove_from_wishlist",
           ss_event_id: window.analyzify.eventId?.reset('remove_from_wishlist') || null,
           ecommerce: {
             ...params,
             currency: window.analyzify.currency,
             value: window.analyzify.formatPrice(itemObj.price, false),
             cart_id: window.analyzify?.cart_id || null,
             items: [itemObj],
           },
           shop_locale: shop?.locale || null,
           shop_country: shop?.country || null,
           market_country: market?.country || null,
           event_location: eventLocation || null,
           market_language: market?.language || null,
           ...pageEventParams,
         ...window.analyzify.breadcrumbCategories,
         cart_quantities: cartQuantities,
           cart_sizes: cartSizes,
           cart_skus: cartSkus,
           cart_units: cartUnits,
           device_type: getDeviceType(),
         });
         
        analyzify.log("Product ee_remove_from_wishlist", 'an_gtm', 'gtmRemoveFromWishList');
      } catch (error) {
        console.error("Error processing remove from wishlist:", error);
      }
    };

      // Begin checkout
      window.analyzify.gtmBeginCheckout = (cartObj) => {
        // Check if begin checkout is enabled
        if (window.analyzify?.properties?.GTM?.enableBeginCheckout === false) {
          return analyzify.log('Begin checkout analytics disabled', 'an_gtm', 'gtmBeginCheckout');
        }
        
        if (!cartObj) {
          return analyzify.log("Cart object is not found", 'an_gtm', 'gtmBeginCheckout');
        }

      const multipleProdsArr = cartObj?.items;
      
      if(!multipleProdsArr) {
        return analyzify.log("Cart items are not found", 'an_gtm', 'gtmBeginCheckout');
      }
      // Get cart data from detectedCart
      const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
      const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
      const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
      const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);
      const pageEventParams = window.analyzify.pageEventParams || {};
      const eventLocation = window.analyzify.buildEventLocation(null, window.analyzify.shopify_template);

      window.dataLayer.push({ ecommerce: null });
      
      const itemObj = {
                 event: "ee_begin_checkout",
         ss_event_id: window.analyzify.eventId?.reset('begin_checkout') || null,
         ecommerce: {
           ...params, 
           currency: window.analyzify.currency,
           value: window.analyzify.formatPrice(cartObj?.total_price, true),
           total_quantity: Number(cartObj?.item_count) || 0,
           total_item: multipleProdsArr.length || 0,
           cart_id: cartObj?.token?.split('?')[0] || window.analyzify?.cart_id || null,
           items: multipleProdsArr.map((item, index) => {
             const item_id = item?.product_id?.toString();
             
             const baseItem = {
               id: item?.handle || null,
               item_id: item?.handle || null,
               item_name: item?.product_title?.trim() || item?.title?.trim() || null,
               price: window.analyzify.formatPrice(item?.price, true),
               currency: window.analyzify?.currency || null,
               item_category: item?.product_type || item?.type || null,
               item_brand: item?.vendor || null,
               item_barcode: null,
               discount: window.analyzify.formatPrice(item?.line_level_total_discount) || 0,
               item_handle: item?.handle || null,
               item_variant: item?.variant_title?.trim() || null,
               item_variant_id: item?.variant_id?.toString() || null,
               item_sku: item?.handle || null,
               index: index,
               quantity: item?.quantity || 1,
               ...(enhanced_params ? {
                 tags: null,
                 taxonomy_id: null,
                 taxonomy_name: null,
                 taxonomy_ancestors: null,
                 options: item?.variant_options?.join(',') || null,
                 variant_ids: item?.variant_id?.toString() || null,  
               } : {}),
               
             };

             // Get item-specific properties from itemProps
             const itemSpecificProps = window.analyzify?.itemProps?.itemProperties?.[item_id];

             // Merge base item with any specific properties
             const finalItem = {
               ...baseItem,
               ...(itemSpecificProps || {})
             };
             
             return finalItem;
           }),
         },
         cat_1: "checkout", 
         shop_locale: shop?.locale || null,
         shop_country: shop?.country || null,
         market_country: market?.country || null,
         market_language: market?.language || null,
         cart_quantities: cartQuantities,
         cart_sizes: cartSizes,
         cart_skus: cartSkus,
         cart_units: cartUnits,
         ...pageEventParams,
        event_location: eventLocation || null,
        device_type: getDeviceType(),


        };
        
        window.dataLayer.push(itemObj);
    };

    // Remove from cart
    window.analyzify.gtmRemoveFromCart = (product, quantityIncrease = false) => {
    const pageEventParams = window.analyzify.pageEventParams || {};

      if (product) {
        const firstVariant = window.analyzify.getFirstVariant(product);
        const eventLocation = window.analyzify.buildEventLocation(product?.handle, window.analyzify.shopify_template);
        
        window.dataLayer.push({ ecommerce: null });
        
        const eventName = quantityIncrease ? "ee_quantity_decreased" : "ee_remove_from_cart";

        const eventData = {
          event: eventName,
          ss_event_id: window.analyzify.eventId?.reset('remove_from_cart') || null,
          ecommerce: {
            ...params,
            currency: window.analyzify.currency,
            cart_id: window.analyzify?.cart_id || null,
            value: window.analyzify.formatPrice(product?.price, true) * (product?.quantity || 1),
            items: [{
                id: product?.handle || null,
                item_id: product?.handle || null,
                item_name: product?.title?.trim() || product?.product_title?.trim() || null,
                price: window.analyzify.formatPrice(product?.price || firstVariant.price, true),
                currency: window.analyzify?.currency || null,
                category_id: gtmObj.getCollectionObj?.id || null,
                item_category: product?.type || product?.product_type || null,
                item_brand: product?.vendor || null,
                discount: window.analyzify.formatPrice(product?.line_level_total_discount) || 0,
                item_barcode: firstVariant?.barcode || null,
                item_variant: product?.variant_title?.trim() || firstVariant?.title?.trim() || null,
                item_variant_id: product?.variant_id?.toString() || firstVariant?.id || null,
                item_sku: product?.handle || null,
                index: 0,
                quantity: product?.quantity || 1,
              }],
          },
          category_id: null, // Product-level event, category would be in item data
          shop_locale: shop?.locale || null,
          shop_country: shop?.country || null,
          market_country: market?.country || null,
          market_language: market?.language || null,
                   ...pageEventParams,
         ...window.analyzify.breadcrumbCategories,
         event_location: eventLocation || null,
         device_type: getDeviceType(),
        };
        
                 window.dataLayer.push(eventData);

         analyzify.log("Product ee_remove_from_cart", 'an_gtm', 'gtmRemoveFromCart');
      } else {
        analyzify.log('DEBUG: gtmRemoveFromCart called with null/undefined product', 'an_gtm', 'gtmRemoveFromCart');
      }
    };

    // Navigation click
      window.analyzify.gtmNavClick = (nav_elem, navTitle, directNavDetail = null) => {
      if (!nav_elem) {
        analyzify.log("No navigation element found.", 'an_gtm', 'gtmNavClick');
        return;
      }

      const tagName = nav_elem.tagName;
      const type = window.analyzify.getTypeFromTag(tagName);
      const title = nav_elem.innerText.trim().split("\n")[0] || "";

      const eventLocation = window.analyzify.buildEventLocation(null, window.analyzify.shopify_template);
      
      analyzify.log(`Navigation click debug - Element: ${tagName}, Title: "${title}", NavTitle: "${navTitle}"`, 'an_gtm', 'gtmNavClick');
      analyzify.log(`Navigation click debug - directNavDetail: "${directNavDetail}"`, 'an_gtm', 'gtmNavClick');
      
      let url = null;
      
      if (nav_elem.hasAttribute("data-url") || nav_elem.hasAttribute("data-link")) {
        url = nav_elem.getAttribute("data-url") || nav_elem.getAttribute("data-link");
      } else if (nav_elem.hasAttribute("href")) {
        url = nav_elem.getAttribute("href");
      } else {
        analyzify.log("No direct URL found on element, searching child elements...", 'an_gtm', 'gtmNavClick');
        

        const summaryElements = nav_elem.querySelectorAll('summary[data-link], summary[data-url]');
        if (summaryElements.length > 0) {
          url = summaryElements[0].getAttribute("data-link") || summaryElements[0].getAttribute("data-url");
          analyzify.log(`Found URL in summary element: ${url}`, 'an_gtm', 'gtmNavClick');
        }
        
        // If still no URL, check for anchor tags
        if (!url) {
          const anchorElements = nav_elem.querySelectorAll('a[href]');
          if (anchorElements.length > 0) {
            url = anchorElements[0].href;
          } else {
            analyzify.log("No anchor elements found", 'an_gtm', 'gtmNavClick');
          }
        }
        
        // If still no URL, check parent element
        if (!url) {
          const parent = nav_elem.parentElement;
          if (parent?.hasAttribute("href")) {
            url = parent.getAttribute("href");
          } else if (parent?.hasAttribute("data-url") || parent?.hasAttribute("data-link")) {
            url = parent.getAttribute("data-url") || parent.getAttribute("data-link");
          } else {
            analyzify.log("No URL found in parent element", 'an_gtm', 'gtmNavClick');
          }
        }
        
        // If still no URL, check for closest elements with relevant attributes
        if (!url) {
          const closestAnchor = nav_elem.closest("a[href]");
          if (closestAnchor) {
            url = closestAnchor.href;
          } else {
            const closestDataLink = nav_elem.closest("[data-url], [data-link]");
            if (closestDataLink) {
              url = closestDataLink.getAttribute("data-url") || closestDataLink.getAttribute("data-link");
            } else {
              analyzify.log("No URL found in any closest elements", 'an_gtm', 'gtmNavClick');
            }
          }
        }
      }
      const pageEventParams = window.analyzify.pageEventParams || {};
        const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
        const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
        const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
        const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);
      
      // Implement simple navDetail retrieval - use direct parameter first, then fallback to sessionStorage
      const sendNavClickEvent = (attempt = 1) => {
        // Use direct navDetail parameter if available, otherwise try to get from sessionStorage
        let navdetail = directNavDetail || getNavdetail('ee_nav_click');
        
        analyzify.log(`gtmNavClick debug - Attempt ${attempt} - About to send ee_nav_click event`, 'an_gtm', 'gtmNavClick');
        analyzify.log(`gtmNavClick debug - directNavDetail: "${directNavDetail}"`, 'an_gtm', 'gtmNavClick');
        analyzify.log(`gtmNavClick debug - navdetail value: "${navdetail}"`, 'an_gtm', 'gtmNavClick');
        analyzify.log(`gtmNavClick debug - sessionStorage azfy_navDetail: "${sessionStorage.getItem('azfy_navDetail')}"`, 'an_gtm', 'gtmNavClick');
        
        // Send the event immediately - no need for complex retry since we have directNavDetail
        window.dataLayer.push({
         event: "ee_nav_click",
         ss_event_id: window.analyzify.eventId?.reset('nav_click') || null,
         ...params,
         cart_id: window.analyzify?.cart_id || null,
         nav: { position: navTitle, type, title, url },
         navdetail,
         shop_locale: shop?.locale || null,
         shop_country: shop?.country || null,
         market_country: market?.country || null,
         market_language: market?.language || null,
         page_type: pushedPage,
        page_currency: window.analyzify?.currency,
        category_id: gtmObj.getCollectionObj?.id || null,
        cart_quantities: cartQuantities,
         cart_sizes: cartSizes,
         cart_skus: cartSkus,
         cart_units: cartUnits,
         device_type: getDeviceType(),
         ...window.analyzify.breadcrumbCategories,
        ...pageEventParams,
       });
       
       analyzify.log(`ee_nav_click event sent with navdetail: "${navdetail}"`, 'an_gtm', 'gtmNavClick');
      };
      
      // Start the send process
      sendNavClickEvent();
    };

    // Select image event - tracks when user selects a different image in product image slider
    window.analyzify.gtmSelectImage = (imageElement) => {
      if (!imageElement) {
        analyzify.log("No image element found.", 'an_gtm', 'gtmSelectImage');
        return;
      }
      
      let interaction_desc = null;
      let sourceUrl = null;
      
      const imgElement = imageElement.querySelector('img[data-srcset]');
      
      if (imgElement) {
        const dataSrcset = imgElement.getAttribute('data-srcset');
        if (dataSrcset) {
          const firstUrl = dataSrcset.split(' ')[0];
          sourceUrl = firstUrl;
          
          const filename = firstUrl.split('/').pop().split('?')[0];
          const parts = filename.split('_');
          
          if (parts.length > 1) {
            // Look for parts that contain identifiers like "_ob:pdp"
            // We want to reconstruct the identifier from parts, excluding size indicators
            const identifierParts = [];
            
            for (let i = 1; i < parts.length; i++) { // Start from 1 to skip the main product name
              const part = parts[i].split('.')[0]; // Remove file extension
              
              // Skip size indicators (like '460x', '1080x', etc.)
              if (/^\d+x?$/.test(part)) {
                continue;
              }
              
              // Skip pure numbers
              if (/^\d+$/.test(part)) {
                continue;
              }
              
              // Include parts that look like identifiers
              if (/^[a-zA-Z0-9:]+$/.test(part)) {
                identifierParts.push(part);
              }
            }
            
            if (identifierParts.length > 0) {
              const templateName = window.analyzify.shopify_template === 'product' ? 'pdp' : window.analyzify.shopify_template;
              interaction_desc = '_' + identifierParts.join('_') + ':' + templateName;
            }
          }
        }
      }
      
      if (!interaction_desc) {
        const dataFullSize = imageElement.getAttribute('data-full-size');
        if (dataFullSize) {
          sourceUrl = dataFullSize;
          const filename = dataFullSize.split('/').pop().split('?')[0];
          const parts = filename.split('_');
          
          if (parts.length > 1) {
            const identifierParts = [];
            
            for (let i = 1; i < parts.length; i++) {
              const part = parts[i].split('.')[0];
              
              if (/^\d+x?$/.test(part) || /^\d+$/.test(part)) {
                continue;
              }
              
              if (/^[a-zA-Z0-9:]+$/.test(part)) {
                identifierParts.push(part);
              }
            }
            
            if (identifierParts.length > 0) {
              const templateName = window.analyzify.shopify_template === 'product' ? 'pdp' : window.analyzify.shopify_template;
              interaction_desc = '_' + identifierParts.join('_') + ':' + templateName;
            }
          }
        }
      }

      const eventLocation = window.analyzify.buildEventLocation(null, window.analyzify.shopify_template);
      const pageEventParams = window.analyzify.pageEventParams || {};
      const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
      const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
      const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
      const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);

      analyzify.log(`Select image debug - interaction_desc: "${interaction_desc}", source URL: "${sourceUrl}"`, 'an_gtm', 'gtmSelectImage');

      let itemObj = null;
      if (window.analyzify?.getProductObj) {
        const productData = window.analyzify.getProductObj;
        if (productData?.product) {
          itemObj = {
            item_id: productData.product.id?.toString() || null,
            item_name: productData.product.title || null,
            item_category: productData.product.type || null,
            item_variant: productData.variant?.title || null,
            price: productData.variant?.price ? (productData.variant.price / 100).toFixed(2) : null,
            currency: window.analyzify?.currency || null,
            item_brand: productData.product.vendor || null,
            category_id: productData.collection.id  || null,
            item_list_name: window.analyzify.shopify_template === 'product' ? 'Product Detail Page' : null,
            index: 1
          };
        }
      }

      window.dataLayer.push({
        event: "ee_select_image",
        ss_event_id: window.analyzify.eventId?.reset('select_image') || null,
        ...params,
        cart_id: window.analyzify?.cart_id || null,
        interaction_name: "select_image",
        interaction_desc: interaction_desc,
        itemObj: itemObj,
        shop_locale: shop?.locale || null,
        shop_country: shop?.country || null,
        market_country: market?.country || null,
        market_language: market?.language || null,
        page_type: pushedPage,
        page_currency: window.analyzify?.currency,
        cart_quantities: cartQuantities,
        cart_sizes: cartSizes,
        cart_skus: cartSkus,
        cart_units: cartUnits,
        device_type: getDeviceType(),
        ...window.analyzify.breadcrumbCategories,
        ...pageEventParams,
      });
    };

    // Submit contact form
    window.analyzify.gtmsubmitContactForm = (formData) => {
      if (window.analyzify.properties?.GA4?.primary?.ga4_contact_form || window.analyzify.properties?.GA4?.secondary?.ga4_contact_form) {
        window.addEventListener("submit", (event) => {
          const formDataObj = new FormData(event.target);
          if (!formDataObj.get('contact[email]')) {
            return;
          }
          const formDataPairs = {};
          for (const [key] of formDataObj.entries()) {
            formDataPairs[key] = formDataObj.get(key);
          }

          if (formDataPairs['form_type'] == 'contact') {
            const contactObj = {
              method: 'contactForm',
              ...formDataPairs
            };
            window.dataLayer.push({
              event: "ee_contact_form",
              ss_event_id: window.analyzify.eventId?.reset('contact_form') || null,
              ...contactObj,
              cart_id: window.analyzify?.cart_id || null,
              category_id: null, // Contact form event, no specific category
              device_type: getDeviceType(),
            });
          }
        });
      }
    };

    // Submit newsletter form
    window.analyzify.gtmsubmitNewsletterForm = (formData) => {
      analyzify.log('gtmsubmitNewsletterForm function called', 'an_gtm', 'gtmSubmitNewsletterForm');
      analyzify.log('formData parameter:', formData, 'an_gtm', 'gtmSubmitNewsletterForm');
      
      const ga4NewsletterEnabled = window.analyzify.properties?.GA4?.primary?.ga4_newsletter || window.analyzify.properties?.GA4?.secondary?.ga4_newsletter;
      analyzify.log('GA4 newsletter tracking enabled:', ga4NewsletterEnabled, 'an_gtm', 'gtmSubmitNewsletterForm');
      
      if (ga4NewsletterEnabled) {
        analyzify.log('Setting up newsletter form submit listener', 'an_gtm', 'gtmSubmitNewsletterForm');
        
        window.addEventListener("submit", (event) => {
          analyzify.log('Form submit event triggered', 'an_gtm', 'gtmSubmitNewsletterForm');
          analyzify.log('Event target:', event.target, 'an_gtm', 'gtmSubmitNewsletterForm');
          
          const formDataObj = new FormData(event.target);
          analyzify.log('FormData created from event target', 'an_gtm', 'gtmSubmitNewsletterForm');
          
          const emailValue = formDataObj.get('contact[email]');
          analyzify.log('Email value from form:', emailValue, 'an_gtm', 'gtmSubmitNewsletterForm');
          
          if (!emailValue) {
            analyzify.log('No email found in form, returning early', 'an_gtm', 'gtmSubmitNewsletterForm');
            return;
          }
          
          const formDataPairs = {};
          for (const [key] of formDataObj.entries()) {
            formDataPairs[key] = formDataObj.get(key);
          }
          analyzify.log('Form data pairs extracted:', formDataPairs, 'an_gtm', 'gtmSubmitNewsletterForm');
          
          const formType = formDataPairs['form_type'];
          analyzify.log('Form type:', formType, 'an_gtm', 'gtmSubmitNewsletterForm');
          
          if (formType == 'customer') {
            analyzify.log('Form type is customer, processing newsletter submission', 'an_gtm', 'gtmSubmitNewsletterForm');
            
            const newsletterObj = {
              send_to: groups,
              eventParams: {
                "method": 'newsletter',
              },
              ...formDataPairs
            };
            analyzify.log('Newsletter object created:', newsletterObj, 'an_gtm', 'gtmSubmitNewsletterForm');
            
            const eventObject = {
              event: "ee_newsletter",
              ss_event_id: window.analyzify.eventId?.reset('newsletter') || null,
              ...newsletterObj,
              cart_id: window.analyzify?.cart_id || null,
              category_id: null, // Newsletter event, no specific category
              device_type: getDeviceType(),
            };
            analyzify.log('Event object to be pushed to dataLayer:', eventObject, 'an_gtm', 'gtmSubmitNewsletterForm');
            
            window.dataLayer.push(eventObject);
            analyzify.log('Event pushed to dataLayer successfully', 'an_gtm', 'gtmSubmitNewsletterForm');
          } else {
            analyzify.log('Form type is not customer, skipping newsletter processing', 'an_gtm', 'gtmSubmitNewsletterForm');
          }
        });
        
        analyzify.log('Newsletter form submit listener setup complete', 'an_gtm', 'gtmSubmitNewsletterForm');
      } else {
        analyzify.log('GA4 newsletter tracking is disabled, skipping setup', 'an_gtm', 'gtmSubmitNewsletterForm');
      }
    };

    // (ee_search event) - triggers when user submits search form
    window.analyzify.gtmSearchAction = (searchTerm) => {
      try {
        if(!searchTerm) return analyzify.log('Search term is not found', 'an_gtm', 'gtmSearchAction');
        
        window.dataLayer.push({ ecommerce: null });

        const pageEventParams = window.analyzify.pageEventParams || {};
        
        const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
        const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
        const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
        const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);

        window.dataLayer.push({
          event: "ee_search",
          ss_event_id: window.analyzify.eventId?.reset('search') || null,
          page_type: window.analyzify.shopify_template || 'other',
          cart_id: window.analyzify?.cart_id || null,
          search_term: searchTerm,
          currency: window.analyzify?.currency,
           category_id: null, // Search event, no specific category
          ...params,
          shop_locale: shop?.locale || null,
          shop_country: shop?.country || null,
          market_country: market?.country || null,
          market_language: market?.language || null,
          device_type: getDeviceType(),
          ...window.analyzify.breadcrumbCategories,
          ...pageEventParams,
          cart_quantities: cartQuantities,
          cart_sizes: cartSizes,
          cart_skus: cartSkus,
          cart_units: cartUnits,
       });
        analyzify.log("ee_search event triggered", 'an_gtm', 'gtmSearchAction');

      } catch (error) {
        console.error("Error processing search action:", error);
      }
    };

    // (ee_account_creation event) - triggers when user submits account creation form
    window.analyzify.gtmAccountCreation = (formElement) => {
      try {
        analyzify.log('Account creation event triggered', 'an_gtm', 'gtmAccountCreation');
        
        if (!formElement) {
          analyzify.log('Form element not found', 'an_gtm', 'gtmAccountCreation');
          return;
        }

        const formData = new FormData(formElement);
        const formDataPairs = {};
        for (const [key, value] of formData.entries()) {
          formDataPairs[key] = value;
        }
        
        analyzify.log('Account creation form data:', formDataPairs, 'an_gtm', 'gtmAccountCreation');

        const customerData = {
          first_name: formDataPairs['customer[first_name]'] || null,
          last_name: formDataPairs['customer[last_name]'] || null,
          email: formDataPairs['customer[email]'] || null,
        };

        const eventLocation = window.analyzify.buildEventLocation(null, window.analyzify.shopify_template);

        // Get cart data from detectedCart
        const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
        const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
        const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
        const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);

        const eventData = {
                   event: "ee_create_account",
         ss_event_id: window.analyzify.eventId?.reset('account_creation') || null,
         page_type: window.analyzify.shopify_template || 'other',
         cart_id: window.analyzify?.cart_id || null,
         currency: window.analyzify?.currency,
         customer_data: {
           first_name: customerData.first_name,
           last_name: customerData.last_name,
           email: customerData.email,
           registration_method: 'website_form'
         },
         form_type: 'create_customer',
         category_id: null, // Account creation event, no specific category
         ...params,
         event_location: eventLocation || null,
         shop_locale: shop?.locale || null,
         shop_country: shop?.country || null,
         market_country: market?.country || null,
         market_language: market?.language || null,
         device_type: getDeviceType(),
         ...window.analyzify.pageEventParams,
         cart_quantities: cartQuantities,
         cart_sizes: cartSizes,
         cart_skus: cartSkus,
         cart_units: cartUnits,
        };

                 // Push to dataLayer
         window.dataLayer.push({ ecommerce: null });
         window.dataLayer.push(eventData);
         
        analyzify.log("ee_account_creation event triggered", 'an_gtm', 'gtmAccountCreation');
        analyzify.log(eventData, 'an_gtm', 'gtmAccountCreation');

      } catch (error) {
        console.error("Error processing account creation:", error);
        analyzify.log(error, 'an_gtm', 'gtmAccountCreation');
      }
    };

    // Initialize and track page
    window.analyzify.gtmInitiated = false; 

    window.analyzify.gtmInitializeAndTrackPage = async () => {
      analyzify.log('gtmInitializeAndTrackPage', 'an_gtm', 'gtmInitializeAndTrackPage');

      if (window.analyzify.gtmInitiated) {
        analyzify.log('GTM initialization already ran. Aborting.', 'an_gtm', 'gtmInitializeAndTrackPage');
        return;
      }
      window.analyzify.gtmInitiated = true;
      analyzify.log('GTM initialization starting. gtmInitiated set to true.', 'an_gtm', 'gtmInitializeAndTrackPage');
      
      
      await window.analyzify.getBreadcrumbCategories();

      // Create page event parameters with UTM data and referrer
      window.analyzify.createPageEventParams();


      // Get cart data from detectedCart
      const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
      const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
      const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
      const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);

      const navdetail = getNavdetail('pageload');
  
      const pageEventParams = window.analyzify.pageEventParams || {};
      // Build dataLayer object with conditional cart data
      const dataLayerObj = {
        event: "sh_info",
        page_type: pushedPage,
        page_currency: window.analyzify?.currency,
        page_id: Date.now(),
        cart_id: window.analyzify?.cart_id || null,
        ss_event_id: window.analyzify.eventId?.reset('default') || null,
        category_id: gtmObj.getCollectionObj?.id || null,
        shop_locale: shop?.locale || null,
        shop_country: shop?.country || null,
        market_country: market?.country || null,
        market_language: market?.language || null,
        user: userData,
        device_type: getDeviceType(),
        ...window.analyzify.storeObj,
        ...params,
        ...window.analyzify.breadcrumbCategories,
        ...pageEventParams,
        cart_quantities: cartQuantities,
        cart_sizes: cartSizes,
        cart_skus: cartSkus,
        cart_units: cartUnits,
        navdetail,
       };

             window.dataLayer.push(dataLayerObj);
       


      if (window.analyzify.shopify_template == "collection") {
        const { products, title, id, handle } = gtmObj.getCollectionObj;

        window.analyzify.gtmViewItemList(title, id, handle, products);
    
      } else if (window.analyzify.shopify_template == "product") {
        if(!gtmObj.getProductObj) {
          return analyzify.log("Product object is not found", 'an_gtm', 'gtmViewItem');
        }
        window.analyzify.gtmViewItem(gtmObj.getProductObj);
      
      } else if (window.analyzify.shopify_template == "cart" || window.analyzify.isPathSegmentPresent('/a/gs/cart/')) {
        window.analyzify.gtmViewCart = (cartObj) => {
          if (!cartObj) return analyzify.log('Cart object is not found', 'an_gtm', 'gtmViewCart');
          if (cartObj?.items?.length == 0) return;

          const ecommerce = {
            currency: window.analyzify.currency,
            value: window.analyzify.formatPrice(cartObj.total_price, true),
            total_quantity: Number(cartObj.item_count),
            total_item: cartObj.items.length,
            cart_id: window.analyzify?.cart_id || null,
          };

        const eventLocation = window.analyzify.buildEventLocation(null, window.analyzify.shopify_template);
        const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
        const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
        const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
        const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);

    
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: "ee_view_cart",
            ss_event_id: window.analyzify.eventId?.reset('view_cart') || null,
            ecommerce: {
              ...params,
              ...ecommerce,
              items: cartObj.items.map((item, index) => {
                return {
                  id: item?.handle || null,
                  item_id: item?.handle || null,
                  item_name: item?.product_title?.trim() || item?.title?.trim() || null,
                  price: window.analyzify.formatPrice(item?.price, true),
                  currency: window.analyzify?.currency || null,
                  item_category: item?.product_type || null,
                  item_brand: item?.vendor || null,
                  item_handle: item?.handle || null,
                  item_barcode: null,
                  discount: window.analyzify.formatPrice(item?.line_level_total_discount, true) || 0,
                  item_variant: item?.variant_title?.trim() || null,
                  item_variant_id: item?.variant_id?.toString() || null,
                  item_sku: item?.handle || null,
                  index: index,
                  quantity: item?.quantity || 1,
                  ...(enhanced_params ? {
                    tags: null,
                    taxonomy_id: null,
                    taxonomy_name: null,
                    taxonomy_ancestors: null,
                    options: item?.variant_options?.join(',') || null,
                    variant_ids: item?.variant_id?.toString() || null,
                  } : {}),
                };
              }),
            },
            category_id: null, // Cart-level event, no specific category
            shop_locale: shop?.locale || null,
            shop_country: shop?.country || null,
            market_country: market?.country || null,
            market_language: market?.language || null,
            device_type: getDeviceType(),
            ...pageEventParams,
            ...window.analyzify.breadcrumbCategories,
            cart_quantities: cartQuantities,
            cart_sizes: cartSizes,
            cart_skus: cartSkus,
            cart_units: cartUnits,
            event_location: eventLocation || null,
           });
        };
        window.analyzify.gtmViewCart(window.analyzify?.detectedCart);
    
      } else if (window.analyzify.shopify_template == "search") {
        window.analyzify.gtmSearch = (searchObj) => {
          try {
            if(!searchObj) return analyzify.log('Search object is not found', 'an_gtm', 'gtmSearch');
            const { term, products, searchPerformed } = searchObj;
            if(!searchPerformed) return analyzify.log('Search is not performed', 'an_gtm', 'gtmSearch');
  
            const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);        
            const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
            const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
            const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);
            const pageEventParams = window.analyzify.pageEventParams || {};

            const items = products.map((item, index) => {
              try {
                const firstVariant = window.analyzify.getFirstVariant(item);
                return {
                  id: item?.handle || null,
                  item_id: item?.handle || null,
                  item_name: item?.product_title?.trim() || item?.title?.trim() || null,
                  item_list_name: `Search Results: ${term}`,
                  category_id: null,
                  position: index,
                  price: window.analyzify.formatPrice(item?.price, true),
                  currency: window.analyzify?.currency || null,
                  item_category: item?.product_type || item?.type || null,
                  item_brand: item?.vendor || null,
                  item_variant: firstVariant?.title?.trim() || null,
                  item_variant_id: firstVariant?.id?.toString() || null,
                  item_sku: item?.handle || null,
                  quantity: item?.quantity || 1,
                  ...(enhanced_params ? {
                    tags: item?.tags?.join(',') || null,
                    options: item?.options?.join(',') || null,
                    taxonomy_id: item?.taxonomy?.id?.toString() || null,
                    taxonomy_name: item?.taxonomy?.name || null,
                    taxonomy_ancestors: item?.taxonomy?.ancestors || null,
                    variant_ids: item?.variants?.map((v) => {
                      return v?.id?.toString() || null;
                    }).join(',') || null,
                  } : {}),
                };
              } catch (error) {
                console.error("Error processing search results:", error);
              }
            });
    
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
               event: "ee_view_search_results",
               ss_event_id: window.analyzify.eventId?.reset('search') || null,
               page_type: "search",
               cart_id: window.analyzify?.cart_id || null,
               search_term: term,
               value: window.analyzify.formatPrice(items.reduce((acc, item) => acc + item.price * item.quantity, 0), false),
               currency: window.analyzify?.currency,
               page_location: window.analyzify.pageEventParams.page_location || null,
               page_name: window.analyzify.pageEventParams.page_name || null,
               page_path: window.analyzify.pageEventParams.page_path || null,
               referring_page: window.analyzify.pageEventParams.referrer || null,
               category_id: null, // Search results event, no specific category
               ...window.analyzify.breadcrumbCategories,
               ...params,
               ecommerce: {
                 item_list_name: `Search Results: ${term}`,
                 category_id: null,
                 items: items,
               },
               shop_locale: shop?.locale || null,
               shop_country: shop?.country || null,
               market_country: market?.country || null,
               market_language: market?.language || null,
               device_type: getDeviceType(),
               cart_quantities: cartQuantities,
              cart_sizes: cartSizes,
              cart_skus: cartSkus,
              cart_units: cartUnits,
              ...pageEventParams,

             });
            analyzify.log("Product ee_search", 'an_gtm', 'gtmSearch');
    
          } catch (error) {
            console.error("Error processing search results:", error);
          }
        };
        window.analyzify.gtmSearch(gtmObj.getSearchObj);
      
      } else if (window.analyzify.shopify_template == "page" && window.location.pathname.includes('/pages/your-wishlist')) {
        // Wishlist page - trigger view_wishlist event
        analyzify.log('Wishlist page detected, gtmViewWishlist function ready', 'an_gtm', 'wishlist');
        
        // Wait a bit for page to fully load and Swym to initialize
        setTimeout(() => {
          // Get wishlist products from localStorage instead of getPageProducts
          try {
            const swymProductsData = localStorage.getItem('swym-products');
            if (swymProductsData) {
              const parsedData = JSON.parse(swymProductsData);
              const wishlistProducts = parsedData?.all || [];
              
              console.log("Wishlist products from localStorage:", wishlistProducts);
              console.log("Wishlist products count:", wishlistProducts.length);

              const transformedProducts = wishlistProducts.map(item => ({
                id: item.empi, // Shopify product ID
                title: item.dt, // Product title
                product_title: item.dt, // Product title (alternative)
                price: item.pr, // Price
                product_type: item.bt, // Brand/type
                type: item.bt, // Brand/type (alternative)
                vendor: item.bt, // Brand
                handle: item.du ? item.du.split('/products/')[1] : null, // Extract handle from URL
                variants: [{
                  id: item.epi, 
                  title: item.vi, 
                  sku: item.sku, 
                  price: item.pr, 
                  available: true
                }],
                quantity: 1
              }));
              
              window.analyzify.gtmViewWishlist(transformedProducts);
            } else {
              console.warn('No swym-products found in localStorage');
              window.analyzify.gtmViewWishlist([]);
            }
          } catch (err) {
            console.warn('Error parsing swym-products from localStorage:', err);
            window.analyzify.gtmViewWishlist([]);
          }
        }, 500);
      }

      analyzify.log('gtmInitializeAndTrackPage', 'an_gtm', 'gtmInitializeAndTrackPage');
    };

    // Initialize GTM
    if (GTM_CONFIG.status) {
      window.analyzify.gtmInitializeAndTrackPage();
    }

    // Cart data collection (if enabled)
    if (window.analyzify.op_cart_data_collection) {
      analyzify.log("🔍 GTM: Cart data collection is enabled", 'an_gtm', 'cart_data');
      analyzify.log("🔍 GTM: checksendcartdata_status =", window.analyzify.checksendcartdata_status, 'an_gtm', 'cart_data');
      if(window.analyzify.checksendcartdata_status == false){
        analyzify.log("✅ GTM: Calling checksendcartdata function", 'an_gtm', 'cart_data');
        window.analyzify_checksendcartdata();
      } else {
        analyzify.log("⚠️ GTM: checksendcartdata_status is true, skipping call", 'an_gtm', 'cart_data');
      }
    } else {
      analyzify.log("❌ GTM: Cart data collection is disabled", 'an_gtm', 'cart_data');
    }

  };

  // Detail Filter Event
  window.analyzify.gtmDetailFilter = (filterData) => {
    const pageEventParams = window.analyzify.pageEventParams || {};
    const cartQuantities = window.analyzify.getCart.quantities(window.analyzify?.detectedCart);
    const cartSizes = window.analyzify.getCart.sizes(window.analyzify?.detectedCart);
    const cartSkus = window.analyzify.getCart.skus(window.analyzify?.detectedCart);
    const cartUnits = window.analyzify.getCart.units(window.analyzify?.detectedCart);
    
    // Get shop and market data
    const market = window.analyzify.market || window.analyzify.cookieStorage?.get('azfy_market');
    const shop = window.analyzify.shop || window.analyzify.cookieStorage?.get('azfy_shop');
    
    // Parse current URL for filter params
    const urlObj = new URL(filterData.currentUrl);
    const params = new URLSearchParams(urlObj.search);
    
    const filterParams = [];
    const priceFilters = { gte: null, lte: null };
    
    for (const [key, value] of params.entries()) {
      if (!key.startsWith('filter.')) continue;
      
      const keyParts = key.split('.');
      const lastPart = keyParts[keyParts.length - 1];
      const isOperator = ['gte', 'lte', 'gt', 'lt'].includes(lastPart);
      
      const filterType = isOperator && keyParts.length >= 3 ? keyParts[keyParts.length - 2] : lastPart;
      const operator = isOperator ? lastPart : null;
      
      if (filterType === 'price' && operator) {
        // Handle price filters
        priceFilters[operator] = value ? decodeURIComponent(value).replace(/\+/g, ' ') : null;
      } else {
        // Handle regular filters
        const filterValue = value ? decodeURIComponent(value).replace(/\+/g, ' ') : '';
        if (filterValue) {
          filterParams.push(`${filterType}:${filterValue}`);
        }
      }
    }
    
    // Add price filters if they have values
    for (const [operator, priceValue] of Object.entries(priceFilters)) {
      if (priceValue !== null) {
        filterParams.push(`price.${operator}:${priceValue}`);
      }
    }
    analyzify.log(`Filter event debug - lastAddedFilter: "${filterData.lastAddedFilter}", currentUrl: "${filterData.currentUrl}"`, 'an_gtm', 'gtmDetailFilter');
    
    window.dataLayer.push({
      event: "ee_detail_filter",
      ss_event_id: window.analyzify.eventId?.reset('detail_filter') || null,
      ...params,
      cart_id: window.analyzify?.cart_id || null,
      interaction_name: "filter_selected", 
      interaction_desc: filterData.lastAddedFilter,
      filter_params: filterParams,
      category_id: window.analyzify.getCollectionObj?.id || null,
      info_url: urlObj.pathname + urlObj.search,
      info_url_prev: filterData.isInitialLoad ? document.referrer : filterData.previousUrl,
      shop_locale: shop?.locale || null,
      shop_country: shop?.country || null,
      market_country: market?.country || null,
      market_language: market?.language || null,
      page_currency: window.analyzify?.currency,
      cart_quantities: cartQuantities,
      cart_sizes: cartSizes,
      cart_skus: cartSkus,
      cart_units: cartUnits,
      ...window.analyzify.breadcrumbCategories,
      ...pageEventParams,
    });

    analyzify.log("Product ee_detail_filter", 'an_gtm', 'gtmDetailFilter');
  };

  // Initialize GTM with settings
  if (GTM_CONFIG.status) {
    analyzify.log('✅ GTM Status: ENABLED', 'an_gtm', 'init');
    analyzify.log('✅ GTM ID:', GTM_CONFIG, 'an_gtm', 'init');
    analyzify.log('✅ Shopify Template:', window.analyzify.shopify_template, 'an_gtm', 'init');

    window.analyzify.initGTM(
      {
        getProductObj: window.analyzify.getProductObj,
        getCollectionObj: window.analyzify.getCollectionObj,
        getSearchObj: window.analyzify.getSearchObj,
        chunk_size: window.analyzify.chunk_size,
        variant_changed_with_view_item: window.analyzify.variant_changed_with_view_item
      },
      {
        enhanced_params: GTM_CONFIG.enhanced_params,
        multiple_view_item_list: GTM_CONFIG.multiple_view_item_list,
        variant_changed: GTM_CONFIG.variant_changed
      }
    );
  } else {
    analyzify.log('❌ GTM Status: DISABLED', 'an_gtm', 'init');
    analyzify.log('❌ GTM_CONFIG:', GTM_CONFIG, 'an_gtm', 'init');
  }

} catch (error) {
  console.error("Error initializing GTM:", error);
}
